export default __webpack_public_path__ + "a92072b639470fab742182884fa554a6.svg";